// extracted by mini-css-extract-plugin
export default {"DetailsList":"cUg8hWst","Detail":"zEefM_qq"};